import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button, Grid, Modal } from 'semantic-ui-react';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

import {
    makeSelectQueryStringBooleanValue,
    makeSelectQueryStringNumberValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import ErrorAlert from 'components/ErrorAlert';

// Child Components
import PersonDeleteModalButton from './components/PersonDeleteModalButton';

import { PersonModal } from '../../constants';

interface StateProps {
    isOpen?: boolean;
    id?: number;
}

interface DispatchProps {
    updateQueryString: Function;
}

type IProps = StateProps & DispatchProps;

export class PersonDeleteModal extends React.PureComponent<IProps> {
    handleClose = () => {
        this.props.updateQueryString({
            [PersonModal.PERSON_DELETE_MODAL]: undefined,
            selectedPerson: undefined
        });
    };

    render(): React.ReactElement | null {
        const { isOpen, id } = this.props;

        if (!id) return null;

        return (
            <Modal
                size="tiny"
                open={isOpen}
                centered={false}
                onClose={this.handleClose}
                closeIcon
            >
                <ErrorBoundary
                    namespace="PersonDeleteModal"
                    FallbackComponent={<ErrorBoundaryAlert />}
                >
                    <Modal.Header>Delete Person</Modal.Header>
                    <Modal.Content>
                        <p>Are you sure you want to delete this person?</p>
                        <p>
                            All unsubmitted timesheet entries for this person
                            will also be deleted.
                        </p>
                        <ErrorAlert namespace="PERSON_DELETE" />
                        <Grid centered>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                <Button
                                    type="button"
                                    onClick={this.handleClose}
                                    fluid
                                    basic
                                    primary
                                >
                                    Cancel
                                </Button>
                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                <PersonDeleteModalButton personId={id} />
                            </Grid.Column>
                        </Grid>
                    </Modal.Content>
                </ErrorBoundary>
            </Modal>
        );
    }
}

const mapStateToProps = createStructuredSelector<any, any>({
    isOpen: makeSelectQueryStringBooleanValue(PersonModal.PERSON_DELETE_MODAL),
    id: makeSelectQueryStringNumberValue('selectedPerson')
});

export default connect<StateProps, DispatchProps>(mapStateToProps, {
    updateQueryString
})(PersonDeleteModal);
